const state = {
    repairSteps: [
        {
            routeName: 'repair.startChecklist',
            title: 'Start Checklist',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.warrantyDetails',
            title: 'Warranty Details',
            makeCodes:[2],
            types:["tablet", "phone"],
            warranty:[true]
        },
        {
            routeName: 'repair.beforePictures',
            title: 'Take Pictures Before',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.addImei',
            title: 'Add IMEI',
            makeCodes:[1, 2],
            types:["phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.addSerialNumber',
            title: 'Add Serial Number',
            makeCodes:[1, 2],
            types:["tablet"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.confirmProblems',
            title: 'Confirm Problems',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.symptomCodes',
            title: 'Symptom Codes',
            makeCodes:[2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.irisCodes',
            title: 'Iris Codes',
            makeCodes:[2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.addParts',
            title: 'Add Parts',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.afterPictures',
            title: 'Take Pictures After',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        },
        {
            routeName: 'repair.repairComplete',
            title: 'Review Repair',
            makeCodes:[1, 2],
            types:["tablet", "phone"],
            warranty:[true, false]
        }
    ]
};

const getters = {
    /** Number of steps in the process */
    numberOfSteps: (__, getters) => {
        return getters.repairSteps.length;
    },

    /** Get the repair steps */
    repairSteps: (state, getters) => {

        let repairStepsToReturn = [];

        state.repairSteps.forEach(repairStep => {
            let makeMatches = false;
            let typeMatches = false;
            let warrantyMatches = false;

            if (getters.device && repairStep.makeCodes.includes(parseInt(getters.device.make_id))) {
                makeMatches = true;
            }

            if (getters.device && repairStep.types.includes(getters.device.type)) {
                typeMatches = true;
            }

            if (getters.device && repairStep.warranty.includes(getters.device.in_warranty)) {
                warrantyMatches = true;
            }

            if (makeMatches && typeMatches && warrantyMatches) {
                repairStepsToReturn.push(repairStep);
            }
        });

        if (!repairStepsToReturn.length) {
            return state.repairSteps;
        }

        return repairStepsToReturn;
    },

    /** Get the current step */
    currentStep: (__, getters) => (routeName) => {
        let currentStep = 0;
        getters.repairSteps.forEach((repairStep, key) => {
            if (repairStep.routeName === routeName) {
                currentStep = key;
            }
        });
        return (currentStep + 1);
    },

    /** Check if a step is active */
    isActiveStep: () => ({repairStep, routeName}) => {
        if (repairStep.routeName === routeName) {
            return true;
        }
        return false;
    },

    /** Check if a step is completed */
    isCompleteStep: () => ({passedRepairStep, currentRouteName}) => {

        let repairStepNumber = 0;
        let currentRouteStepNumber = 0;

        state.repairSteps.forEach((repairStep, key) => {
            if (repairStep.routeName === passedRepairStep.routeName) {
                repairStepNumber = key;
            }

            if (repairStep.routeName === currentRouteName) {
                currentRouteStepNumber = key;
            }
        });

        if (repairStepNumber < currentRouteStepNumber) {
            return true;
        }

        return false;
    },

    /** Get the next step */
    nextRepairStep: (__, getters) => (routeName) => {
        let nextStepKey = 0;

        getters.repairSteps.forEach((repairStep, key) => {
            if (repairStep.routeName === routeName) {
                nextStepKey = key + 1;
            }
        });

        return getters.repairSteps[nextStepKey];
    },

    /** Get the last step */
    prevRepairStep: (__, getters) => (routeName) => {
        let prevStepKey = 0;

        getters.repairSteps.forEach((repairStep, key) => {
            if (repairStep.routeName === routeName) {
                prevStepKey = key - 1;
            }
        });

        return getters.repairSteps[prevStepKey];
    }
};

const actions = {

};

const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations
}